import React from 'react';
import { useChatContext } from '../context/chat-context';

const LoadingMessage = () => {
  const { isSending } = useChatContext();

  if (!isSending) return null;

  return (
    <div className="react-chatbot-kit-chat-bot-message-container">
      <div className="react-chatbot-kit-chat-bot-avatar-container">
        <p className="react-chatbot-kit-chat-bot-avatar-letter">B</p>
      </div>
      <div 
        style={{
          backgroundColor: '#f0f0f0',
          padding: '12px 15px',
          borderRadius: '15px 15px 15px 0',
          margin: '8px 0',
          maxWidth: '85%',
          alignSelf: 'flex-start',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="chatbot-loader-container">
          <div id="chatbot-loader">
            <span id="chatbot-loader-dot1">.</span>
            <span id="chatbot-loader-dot2">.</span>
            <span id="chatbot-loader-dot3">.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingMessage;
